import ReactModel from './ReactModel'

/**
 * Represents a new Invoice Item being added.
 */
export default class InvoiceItemTemplate extends ReactModel<InvoiceItemTemplateData> {
    constructor(data: Partial<InvoiceItemTemplateData> = {}) {
        super({
            name: '',
            amount: '', // We'd prefer to use a number, but textboxes expect strings
            rateType: null, // "PERCENT" or "FIXED"
            type: null, // "FEE" or "DISCOUNT"
            appliesToFeeIds: [],
            appliesToThis: new Set(), // list of Invoice Item keys
            percentageOf: new Set(), // list of Invoice Item keys
            percentOfBase: true,
            feeId: null,
            ...data,
        });
    }
}

export type FixedOrPercent = "PERCENT"|"FIXED"
export type FeeOrDiscount = "FEE"|"DISCOUNT"

export interface InvoiceItemTemplateData {
    name: string
    amount: StringNum
    rateType: FixedOrPercent|null
    type: FeeOrDiscount|null
    appliesToFeeIds: number[]
    appliesToThis: Set<string>
    /** Invoice item keys */
    percentageOf: Set<string>
    percentOfBase: boolean
    feeId: string|null
}

export interface InvoiceItemTemplateModel extends InvoiceItemTemplateData {
    id: null|string|number
    key: string
}
